export const statusListArr = [
  'RECEIVED',
  'READY',
  'ARCH_CMPL',
  'READY_REPR_ALL',
  'ARCH_REPR_PART_CMPL',
  'REPROCESSING_ALL',
  'REPROCESSING ALL',
  'ERROR',
  'FL_REJ_DATA_PROB',
  'PROCESSING',
  'FAILED',
  'PROCESSED',
  'REPR_PART',
  'FAIL',
  'PROCESSED_WITH_ERRORS',
  'PROCESSED_WITH_WARNINGS',
  'REPROCESSING',
  'CANCELLED',
];
